var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgTon = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 147,
    height: 60,
    viewBox: "0 0 147 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_207_26)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_207_26",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 147,
    height: 56
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M147 0H0V56H147V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_207_26)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.1654 28C56.1654 43.464 43.6294 56 28.1654 56C12.7014 56 0.165405 43.464 0.165405 28C0.165405 12.536 12.7014 0 28.1654 0C43.6294 0 56.1654 12.536 56.1654 28ZM18.6039 15.6277H37.7256H37.7281C41.2414 15.6277 43.4698 19.4251 41.7034 22.4861L29.8998 42.9409C29.1297 44.2765 27.1998 44.2765 26.4297 42.9409L14.6285 22.4861C12.8598 19.4202 15.0881 15.6277 18.6039 15.6277ZM26.4177 36.8021V19.1218H18.6015C17.7448 19.1218 17.2395 20.0315 17.6486 20.7414L23.85 31.8327L26.4177 36.8021ZM32.4771 31.8351L38.6761 20.739C39.0853 20.0291 38.5799 19.1194 37.7233 19.1194H29.907V36.8068L32.4771 31.8351Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8158 43.4675H80.0872V21.5962H88.7587V15.6384H65.144V21.5962H73.8158V43.4675Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.831 43.9378C111.748 43.9378 118.216 37.4705 118.216 29.5529C118.216 21.6354 111.748 15.168 103.831 15.168C95.874 15.168 89.4459 21.6354 89.4459 29.5529C89.4459 37.4705 95.874 43.9378 103.831 43.9378ZM103.831 37.9016C99.284 37.9016 95.7172 34.0604 95.7172 29.5529C95.7172 25.0454 99.284 21.2042 103.831 21.2042C108.338 21.2042 111.905 25.0454 111.905 29.5529C111.905 34.0604 108.338 37.9016 103.831 37.9016Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.835 43.4675V15.6384H140.563V32.8062L127.041 15.6384H121.671V43.4675H127.903V26.2605L141.465 43.4675H146.835Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_207_26"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 147,
    height: 56,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ton.1833e5056b07e8d90c58534d2ba3401e.svg";